import PropTypes from 'prop-types';
import React from 'react';

import { Trans, withTranslation } from 'react-i18next';

import { List, Button } from 'semantic-ui-react';
import ActionPicker, { SelectButtons } from './components/attendeesActions';

class AttendeesSidebar extends React.Component {
    renderAttendeeSeat(attendee) {
        const { t } = this.props;
        let text = `${t('attendee.seat')} `;

        if (!attendee.booking) {
            return null;
        }

        if (attendee.booking.isGA) {
            text += t('attendee.seatIsInGA');
        } else {
            let seat = attendee.booking.seat;
            let row = attendee.booking.row;
            let access = attendee.booking.access;
            let zone = attendee.booking.zoneName;
            text += `: ${zone} - S${seat} R${row} - Access: ${access}`;
        }

        return <div>{text}</div>;
    }

    renderAttendeeItem(attendee) {
        const { t } = this.props;
        return (
            <List.Item className={'item-padding'} key={attendee.id} onClick={() => this.onAttendeeClick(attendee)}>
                <div className="attendee-list-item">
                    <span className="attendee-list-order">O#{attendee.order.transaction_reference}</span>
                    <span className="attendee-list-name">
                        {attendee.first_name} {attendee.last_name}
                    </span>
                    {this.renderAttendeeSeat(attendee)}
                    <Button
                        primary
                        onClick={() => {
                            this.props.goToAttendee(attendee.id);
                        }}
                        content={t('ticket.attendee.viewProfile')}
                    />
                </div>
            </List.Item>
        );
    }

    onAttendeeClick(attendee) {
        return this.props.deselectOne(attendee);
    }

    renderAttendeesList() {
        let { selectedAttendees: attendees } = this.props;
        let sortedAttendees = attendees.slice(0);
        sortedAttendees.sort((attendee1, attendee2) => {
            // sort by order to group them
            return attendee1.order.id_transaction - attendee2.order.id_transaction;
        });

        return <List>{sortedAttendees.map(attendee => this.renderAttendeeItem(attendee))}</List>;
    }

    renderAttendeesActions() {
        return <ActionPicker event={this.props.event} selectedAttendees={this.props.selectedAttendees} onChange={this.props.onActionChange} />;
    }

    renderButtons() {
        return (
            <React.Fragment>
                <SelectButtons deselectAll={() => this.props.deselectAll()} selectAll={() => this.props.selectAll()} selectedAttendees={this.props.selectedAttendees} />
            </React.Fragment>
        );
    }

    render() {
        // select all/ deselect
        // selected attendees list
        // actions
        return (
            <div>
                <div>
                    <h3>
                        <Trans i18nKey="attendees.selected">Selected attendees</Trans>
                        {this.props.selectedAttendees.length ? ` (${this.props.selectedAttendees.length})` : null}
                    </h3>
                </div>
                {this.renderButtons()}
                {this.renderAttendeesActions()}
                {this.renderAttendeesList()}
            </div>
        );
    }
}

AttendeesSidebar.propTypes = {
    event: PropTypes.object.isRequired,
    deselectAll: PropTypes.func.isRequired,
    deselectOne: PropTypes.func.isRequired,
    onActionChange: PropTypes.func.isRequired,
    selectedAttendees: PropTypes.array.isRequired,
    selectAll: PropTypes.func.isRequired,
    goToAttendee: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired
};

export default withTranslation()(AttendeesSidebar);
